export function calculateRiskRewardRatio(
	num1: number,
	num2: number,
	targetPrice: number,
	isLong: boolean,
): number {
	const entryPrice = isLong ? num1 : num2
	const stopLoss = isLong ? num2 : num1

	const risk = Math.abs(entryPrice - stopLoss)
	const reward = Math.abs(targetPrice - entryPrice)

	return reward / risk
}
